/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Card, Checkbox, Tag } from "antd";
import { PlusIcon } from "../../../../../../atoms/CustomIcons";

export default function TabCheckList() {
  return (
    <div className="dashboardTabContent">
      <div className="checklist">
        <div className="title">
          <h4>Checklist</h4>
          <Button
            className="outlined-btn"
            size="small"
            style={{ height: "28px", width: "28px", padding: "0" }}
          >
            <PlusIcon />
          </Button>
        </div>
        <div className="content">
          <Card
            className="checklistCard dashboardChecklistCard"
            style={{ marginBottom: "8px" }}
          >
            <div className="checkList_listing">
              <Checkbox checked>
                Materials sourced and delivered to site
              </Checkbox>
              <div className="checklistFooter">
                <Tag className="grey_tag"> Due: Apr 23 </Tag>
                <div style={{ marginLeft: 8 }}>
                  <img
                    src="/images/potential-deals/avatar.png"
                    alt=""
                    style={{
                      width: "28px",
                      height: "28px",
                      border: "1px solid #C7D1D4",
                      borderRadius: "100%",
                    }}
                  />
                </div>
              </div>
            </div>
          </Card>
          <Card
            className="checklistCard dashboardChecklistCard"
            style={{ marginBottom: "8px" }}
          >
            <div className="checkList_listing">
              <Checkbox checked>
                Materials sourced and delivered to site
              </Checkbox>
              <div className="checklistFooter">
                <Tag className="grey_tag"> Due: Apr 23 </Tag>
                <div style={{ marginLeft: 8 }}>
                  <img
                    src="/images/potential-deals/avatar.png"
                    alt=""
                    style={{
                      width: "28px",
                      height: "28px",
                      border: "1px solid #C7D1D4",
                      borderRadius: "100%",
                    }}
                  />
                </div>
              </div>
            </div>
          </Card>
          <Card
            className="checklistCard dashboardChecklistCard"
            style={{ marginBottom: "8px" }}
          >
            <div className="checkList_listing">
              <Checkbox checked>
                Materials sourced and delivered to site
              </Checkbox>
              <div className="checklistFooter">
                <Tag className="grey_tag"> Due: Apr 23 </Tag>
                <div style={{ marginLeft: 8 }}>
                  <img
                    src="/images/potential-deals/avatar.png"
                    alt=""
                    style={{
                      width: "28px",
                      height: "28px",
                      border: "1px solid #C7D1D4",
                      borderRadius: "100%",
                    }}
                  />
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
}
